import { FC } from 'react';
import { Title } from 'UI';
import { withStyles } from 'vopay';
import styles from './ApprovalPanel.module.scss';

const cn = withStyles(styles);

type ApprovalPanelProps = {
  title: string;
  description: string;
  className?: string;
};

const ApprovalPanel: FC<ApprovalPanelProps> = ({ title, description, className }) => (
  <div className={cn('ContainerPanel', 'pdfSolidBg', className)} data-pdf-bg="rgb(229, 242, 230)">
    <Title level="5" className={cn('title')}>
      {title}:
    </Title>
    <Title level="5" className={cn('title')} emphasized={false}>
      {description}
    </Title>
  </div>
);

export default ApprovalPanel;
